import { useState, useCallback } from 'react';
import { createPortal } from 'react-dom';
import '../styles/GaleriaImagenes.css';

const FALLBACK = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="300" height="220"><rect fill="%232d2d2d" width="300" height="220"/><text fill="%23666" font-size="14" font-family="sans-serif" x="50%25" y="50%25" dominant-baseline="middle" text-anchor="middle">Sin imagen</text></svg>';

const GaleriaImagenes = ({ imagen, imagenes, nombre, productoId }) => {
  const todasLasImagenes = (imagenes && imagenes.length > 0) ? imagenes : (imagen ? [imagen] : []);
  const total = todasLasImagenes.length;

  const [indice, setIndice] = useState(0);
  const [lightbox, setLightbox] = useState(false);
  const [imgError, setImgError] = useState({});

  const anterior = useCallback((e) => {
    e.stopPropagation();
    setIndice(i => (i - 1 + total) % total);
  }, [total]);

  const siguiente = useCallback((e) => {
    e.stopPropagation();
    setIndice(i => (i + 1) % total);
  }, [total]);

  const abrirLightbox = () => {
    setLightbox(true);
    // Registrar visita una sola vez por sesión por producto
    if (productoId) {
      const key = `visitado_${productoId}`;
      if (!sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, '1');
        fetch(`/api/productos/${productoId}/visita`, { method: 'POST' }).catch(() => {});
      }
    }
  };
  const cerrarLightbox = () => setLightbox(false);

  const srcActual = imgError[indice] ? FALLBACK : (todasLasImagenes[indice] || FALLBACK);

  return (
    <>
      <div className="galeria-wrapper">
        <img
          src={srcActual}
          alt={nombre}
          className="galeria-img"
          onClick={abrirLightbox}
          onError={() => setImgError(prev => ({ ...prev, [indice]: true }))}
        />

        {total > 1 && (
          <>
            <button className="galeria-flecha galeria-flecha-izq" onClick={anterior} title="Anterior">
              ‹
            </button>
            <button className="galeria-flecha galeria-flecha-der" onClick={siguiente} title="Siguiente">
              ›
            </button>
            <span className="galeria-contador">{indice + 1}/{total}</span>
            <div className="galeria-dots">
              {todasLasImagenes.map((_, i) => (
                <span
                  key={i}
                  className={`galeria-dot${i === indice ? ' activo' : ''}`}
                  onClick={(e) => { e.stopPropagation(); setIndice(i); }}
                />
              ))}
            </div>
          </>
        )}
      </div>

      {lightbox && createPortal(
        <div className="lightbox-overlay" onClick={cerrarLightbox}>
          <button className="lightbox-cerrar" onClick={cerrarLightbox} title="Cerrar">✕</button>

          {total > 1 && (
            <button className="lightbox-flecha lightbox-flecha-izq" onClick={anterior}>‹</button>
          )}

          <div className="lightbox-contenido" onClick={e => e.stopPropagation()}>
            <img
              src={imgError[indice] ? FALLBACK : (todasLasImagenes[indice] || FALLBACK)}
              alt={nombre}
              className="lightbox-img"
              onError={() => setImgError(prev => ({ ...prev, [indice]: true }))}
            />
            {total > 1 && (
              <span className="lightbox-contador">{indice + 1} / {total}</span>
            )}
          </div>

          {total > 1 && (
            <button className="lightbox-flecha lightbox-flecha-der" onClick={siguiente}>›</button>
          )}
        </div>,
        document.body
      )}
    </>
  );
};

export default GaleriaImagenes;
